import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { metaContentZodSchema } from "@@/shared/meta-content/meta-content";
import { quantityZodSchema } from "@@/shared/units-and-quantities/quantity";
import { unitZodSchema } from "@@/shared/units-and-quantities/unit";
import { z } from "zod";
import { resourcePriceZodSchema } from "../resource-price/resource-price";
import { resourceReferenceIdZodSchema } from "../resource-references/resource-reference-id";
import { resourceIdZodSchema } from "../resources/resource-id";
import { bookableOptionIdZodSchema } from "./bookable-option-id";
import type { BookableOptionValue } from "./bookable-option-value";
import { bookableOptionValueIdZodSchema } from "./bookable-option-value-id";
import type { ManifestBookableOptionValue } from "./manifest-bookable-option-value";
import { manifestFieldValueZodSchema } from "./manifest-field-value";
import type { QuantityPickerBookableOptionValue } from "./quantity-picker-bookable-option-value";

// QUICK FIXED CIRCULAR DEPENDENCY WARNING BY
// GATHERING THE ZOD SCHEMAS HERE IN THIS FILE,
const quantityPickerBookableOptionValueZodObject = z.object({
    _id: bookableOptionValueIdZodSchema,
    _type: z.literal("QUANTITY_PICKER_BOOKABLE_OPTION_VALUE"),
    _createdAt: isoAndUnixZodSchema,
    resourceReferenceId: resourceReferenceIdZodSchema,
    resourceId: resourceIdZodSchema,
    parentId: bookableOptionIdZodSchema,
    meta: metaContentZodSchema,
    resourcePrice: resourcePriceZodSchema,
    quantity: quantityZodSchema,
});

const quantityPickerBookableOptionValueZodSchema: z.ZodSchema<QuantityPickerBookableOptionValue> =
    quantityPickerBookableOptionValueZodObject;

const manifestBookableOptionValueZodObject = z.object({
    _id: bookableOptionValueIdZodSchema,
    _type: z.literal("MANIFEST_BOOKABLE_OPTION_VALUE"),
    _createdAt: isoAndUnixZodSchema,
    resourceReferenceId: resourceReferenceIdZodSchema,
    resourceId: resourceIdZodSchema,
    meta: metaContentZodSchema,
    parentId: bookableOptionIdZodSchema,
    unit: unitZodSchema,
    manifest: z.array(manifestFieldValueZodSchema),
});
const manifestBookableOptionValueZodSchema: z.ZodSchema<ManifestBookableOptionValue> =
    manifestBookableOptionValueZodObject;

const bookableOptionValueZodSchema: z.ZodSchema<BookableOptionValue> =
    z.discriminatedUnion("_type", [
        quantityPickerBookableOptionValueZodObject,
        manifestBookableOptionValueZodObject,
    ]);

export {
    bookableOptionValueZodSchema,
    manifestBookableOptionValueZodObject,
    manifestBookableOptionValueZodSchema,
    quantityPickerBookableOptionValueZodObject,
    quantityPickerBookableOptionValueZodSchema,
};
